import i18n from '@dms/i18n';

import {Field} from './primitives/Field';

export function ServiceContractUntilDatePicker() {
  return (
    <Field
      type="apiDate"
      name="serviceContractUntil"
      label={i18n.t('entity.vehicle.labels.serviceContractUntil')}
    />
  );
}
